export const apiHost = {
  "DEV": {
    "us-west-2": 'https://l0v7hqc056.execute-api.us-west-2.amazonaws.com'
  },
  "BETA": {
    "us-west-2": 'https://i9p4cit4gb.execute-api.us-west-2.amazonaws.com'
  },
  "GAMMA": {
    "eu-west-1": 'https://ns5dsxvcz0.execute-api.eu-west-1.amazonaws.com',
    "us-east-1": 'https://bh1vge71si.execute-api.us-east-1.amazonaws.com',
    "us-west-2": 'https://ubok6bqwhd.execute-api.us-west-2.amazonaws.com'
  },
  "PROD": {
    "eu-west-1": 'https://j7ch8r2cui.execute-api.eu-west-1.amazonaws.com',
    "us-east-1": 'https://h1hpn38ap8.execute-api.us-east-1.amazonaws.com',
    "us-west-2": 'https://0y7yf1vt2c.execute-api.us-west-2.amazonaws.com'
  }
}

export const groundingGenerationApiHost = {
  "DEV": {
    "us-west-2": 'https://1u5yhlq3g9.execute-api.us-west-2.amazonaws.com'
  },
  "BETA": {
    "us-west-2": 'https://1u5yhlq3g9.execute-api.us-west-2.amazonaws.com'
  },
  "GAMMA": {
    "eu-west-1": 'https://1u5yhlq3g9.execute-api.us-west-2.amazonaws.com',
    "us-east-1": 'https://1u5yhlq3g9.execute-api.us-west-2.amazonaws.com',
    "us-west-2": 'https://1u5yhlq3g9.execute-api.us-west-2.amazonaws.com'
  },
  "PROD": {
    "eu-west-1": 'https://f70tij0t1f.execute-api.us-east-1.amazonaws.com',
    "us-east-1": 'https://f70tij0t1f.execute-api.us-east-1.amazonaws.com',
    "us-west-2": 'https://f70tij0t1f.execute-api.us-east-1.amazonaws.com'
  }
}

export const mmirUIIssueReportingApiHost = {
  "PROD": {
    "us-east-1": 'https://oya3kptop4.execute-api.us-east-1.amazonaws.com',
  }
}

export const textToAkgEntityLinkingApiHost = {
  "DEV": {
    "us-west-2": "https://3wc0pamx68.execute-api.us-west-2.amazonaws.com"
  },
  "BETA": {
    "us-west-2": 'https://3wc0pamx68.execute-api.us-west-2.amazonaws.com'
  },
  "PROD": {
    "us-east-1": 'https://n2g9l6hzrh.execute-api.us-east-1.amazonaws.com'
  }
}

export const visualQaExperimentalApiHost = {
  "DEV": {
    "us-west-2": 'https://mp02seezsf.execute-api.us-east-1.amazonaws.com'
  },
  "BETA": {
    "us-west-2": 'https://mp02seezsf.execute-api.us-east-1.amazonaws.com'
  },
  "GAMMA": {
    "eu-west-1": 'https://mp02seezsf.execute-api.us-east-1.amazonaws.com',
    "us-east-1": 'https://mp02seezsf.execute-api.us-east-1.amazonaws.com',
    "us-west-2": 'https://mp02seezsf.execute-api.us-east-1.amazonaws.com'
  },
  "PROD": {
    "eu-west-1": 'https://mp02seezsf.execute-api.us-east-1.amazonaws.com',
    "us-east-1": 'https://mp02seezsf.execute-api.us-east-1.amazonaws.com',
    "us-west-2": 'https://mp02seezsf.execute-api.us-east-1.amazonaws.com'
  }
}

const lensBetaAgentCoreUrl = 'https://bedrock-agentcore.us-east-1.amazonaws.com/runtimes/arn%3Aaws%3Abedrock-agentcore%3Aus-east-1%3A178648534186%3Aruntime%2Fmmir_lens_beta_agent-iFCIaM5rpc/invocations?qualifier=DEFAULT';
const lensProdIadAgentCoreUrl = 'https://bedrock-agentcore.us-east-1.amazonaws.com/runtimes/arn%3Aaws%3Abedrock-agentcore%3Aus-east-1%3A178648534186%3Aruntime%2Fmmir_lens_agent-j1holr6NA4/invocations?qualifier=DEFAULT';

// Lens owns this browser/JWT runtime. It invokes the production VTAG Lambda,
// whose ICG leg is routed to production MMR, without changing VisualQaHandler.
export const lensApiHost = {
  "DEV": { "us-west-2": lensBetaAgentCoreUrl },
  "BETA": { "us-west-2": lensBetaAgentCoreUrl },
  "GAMMA": {},
  "PROD": { "us-east-1": lensProdIadAgentCoreUrl }
};

export const visualQaDataUploadApiHost = {
  "DEV": {
    "us-west-2": 'https://5bryq529z4.execute-api.us-west-2.amazonaws.com'
  },
  "BETA": {
    "us-west-2": 'https://5bryq529z4.execute-api.us-west-2.amazonaws.com'
  },
  "GAMMA": {
    "eu-west-1": 'https://5bryq529z4.execute-api.us-west-2.amazonaws.com',
    "us-east-1": 'https://5bryq529z4.execute-api.us-west-2.amazonaws.com',
    "us-west-2": 'https://5bryq529z4.execute-api.us-west-2.amazonaws.com'
  },
  "PROD": {
    "eu-west-1": 'https://5bryq529z4.execute-api.us-west-2.amazonaws.com',
    "us-east-1": 'https://5bryq529z4.execute-api.us-west-2.amazonaws.com',
    "us-west-2": 'https://5bryq529z4.execute-api.us-west-2.amazonaws.com'
  }
}
